/** @format */

import React from "react";
import Index from "../../views/dashboard/index";

import ErrorRoute from "../../router/error-route";

export const PublicRouter = [
  {
    key: "index",
    path: "/",
    element: <Index />,
  },
  {
    key: "error",
    path: "*",
    element: <ErrorRoute />,
  },
];
